<template>
    <v-layout row justify-center>
        <v-dialog v-model="show" persistent max-width="600">
            <v-toolbar color="red lighten-5" flat>
                <v-toolbar-title class="body-2 grey--text">{{$t('reminder.dialog.box.heading')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeDialog()">
                    <v-icon color='error'>$vuetify.icons.rms_close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card >
                 <v-card-title v-if="error" primary-title>
                    <div>
                        <div class="headline pb-4">{{error.title}}</div>
                        <div class="subheading" >{{error.message}}</div>
                        <span class="subheading" >{{error.remedy}}</span>
                    </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red lighten-1" flat @click="closeDialog()">{{$t('reminder.dialog.box.button.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
export default {
    props:['show','error'],
    name:'ReminderMessageDialog',
    data() {
        return {
            dialog: true
        }
    },
    methods: {
        async closeDialog() {
            await this.$store.dispatch("app/hideErrorMessageDialog");
        }
    }
}
</script>
